export class RevisitNumber {
    public static values = Array.from({ length: 21 }, (_, i) => i.toString());
}